/* eslint-disable */
// GENERATED by scripts/gen-config.js from src/config/prod.json - do not edit or commit.
export default {
  "env": "prod",
  "amplify": {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
      {
        "name": "dbcsiAPI",
        "endpoint": "https://n8uw05cde5.execute-api.us-east-1.amazonaws.com/prod",
        "region": "us-east-1"
      },
      {
        "name": "dbcsiPublicAPI",
        "endpoint": "https://zvpj0w4ua1.execute-api.us-east-1.amazonaws.com/prod",
        "region": "us-east-1"
      }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:b571b7df-2792-4d43-9342-4efc544fde65",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_UK7SVZPJv",
    "aws_user_pools_web_client_id": "7098nk74a3vm1un5r0i9lnhjfe",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
      "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
      "SMS"
    ],
    "aws_cognito_password_protection_settings": {
      "passwordPolicyMinLength": 8,
      "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
      "EMAIL"
    ],
    "aws_user_files_s3_bucket": "aws-dbcsi144107-prod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_cognito_login_mechanisms": [
      "PREFERRED_USERNAME"
    ]
  },
  "oauthDomain": "dbcsi-prod.auth.us-east-1.amazoncognito.com"
};
